import type { ReactElement, ReactNode } from 'react'

export interface PanelProps {
  readonly title?: string
  readonly className?: string
  readonly children: ReactNode
}

/** 只负责「深色卡片」外观（对应旧版 .panel），不做任何业务 */
export function Panel({ title, className, children }: PanelProps): ReactElement {
  return (
    <section className={className ? `panel ${className}` : 'panel'}>
      {title ? <h2 className="mb-3 text-base font-semibold">{title}</h2> : null}
      {children}
    </section>
  )
}
